import LowRiskGaugeImage from 'src/modules/3rd-party-management/assets/images/low-risk-gauge-image.png';
import MediumRiskGaugeImage from 'src/modules/3rd-party-management/assets/images/medium-risk-gauge-image.png';
import HighRiskGaugeImage from 'src/modules/3rd-party-management/assets/images/high-risk-gauge-image.png';

export const RISK_GAUGE_IMAGES = {
    low: LowRiskGaugeImage,
    medium: MediumRiskGaugeImage,
    high: HighRiskGaugeImage,
};

export const RISK_LEVEL_CONFIG = {
    low: {
        label: 'Low',
        color: '#1CBB8C',
    },
    medium: {
        label: 'Medium',
        color: '#F2994A',
    },
    high: {
        label: 'High',
        color: '#EB5757',
    },
};

export const getRiskGaugeImage = (riskLevel) => {
    const normalizedLevel = (riskLevel || '').toString().toLowerCase();

    return RISK_GAUGE_IMAGES[normalizedLevel] || RISK_GAUGE_IMAGES.medium;
};

export const getRiskLevelConfig = (riskLevel) => {
    const normalizedLevel = (riskLevel || '').toString().toLowerCase();

    return RISK_LEVEL_CONFIG[normalizedLevel] || RISK_LEVEL_CONFIG.medium;
};
